<template>
  <dialog-component
    :dialogData="dialogData"
    :isShow="isShow"
    width="800">
    <article-html :content="content" />
  </dialog-component>
</template>
<script>
import ArticleHtml from '../article-html'
export default {
  name: 'PostPreview',
  components: {
    ArticleHtml
  },
  props: {
    value: {
      type: Boolean,
      default: false
    },
    content: {
      type: Object,
      default: null
    }
  },
  data() {
    return {
      isShow: false
    }
  },
  computed: {
    dialogData() {
      return {
        title: 'Post Preview',
      }
    }
  },
  watch: {
    value: {
      immediate: true,
      handler(status) {
        if(status !== this.isShow) {
          this.isShow = status
        }
      }
    },
    isShow: {
      handler(status) {
        if(status !== this.value) {
          this.$emit('input', status)
        }
      }
    }
  }
}
</script>